module.exports = __webpack_public_path__ + "img/gantanhao.10aa5f84.png";